// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DESIGN INVARIANT (2026-05-19):
   --sidebar-width and --carousel-tray-height MUST hold a 2:1 ratio
   (sidebar = 2 × tray). The carousel tray height MUST equal the bottom-left
   status dock (.corner-dock) min-height at the same density so they sit
   flush along their top edge. The tray height also needs ~10px breathing
   over the dock's natural content floor so the inner rows don't feel
   cramped — standard = 140 (content floor 134 + 6 breathing), compact = 110
   (content floor 104 + 6 breathing). See wiki/decisions/2026-05-19-dock-carousel-sidebar-proportion.md
   Source of truth for dock floors: BottomLeftStatusRail.css. */
:root {
  --sidebar-width: 280px;
  --carousel-tray-height: 140px;
  --carousel-thumb-height: 120px;
  --carousel-thumb-width: 240px;
  --carousel-bar-pad-top: 16px;
  --carousel-bar-pad-bottom: 12px;
}

:root[data-ui-density="compact"] {
  --sidebar-width: 220px;
  --carousel-tray-height: 110px;
  --carousel-thumb-height: 86px;
  --carousel-thumb-width: 188px;
  --carousel-bar-pad-top: 8px;
  --carousel-bar-pad-bottom: 6px;
}

:root[data-ui-density="standard"] {
  --sidebar-width: 280px;
  --carousel-tray-height: 140px;
  --carousel-thumb-height: 120px;
  --carousel-thumb-width: 240px;
  --carousel-bar-pad-top: 16px;
  --carousel-bar-pad-bottom: 12px;
}

:root[data-ui-density="spacious"] {
  --sidebar-width: 340px;
  --carousel-tray-height: 170px;
  --carousel-thumb-height: 144px;
  --carousel-thumb-width: 280px;
  --carousel-bar-pad-top: 22px;
  --carousel-bar-pad-bottom: 16px;
}

@media (max-width: 1024px) {
  :root,
  :root[data-ui-density="compact"],
  :root[data-ui-density="standard"],
  :root[data-ui-density="spacious"] {
    --sidebar-width: 260px;
  }
}

@media (max-width: 768px) {
  :root,
  :root[data-ui-density="compact"],
  :root[data-ui-density="standard"],
  :root[data-ui-density="spacious"] {
    --sidebar-width: 0px;
  }
}

.sidebar-shell {
  width: var(--sidebar-width);
  min-width: var(--sidebar-width);
  background: transparent;
  border-right: 1px solid var(--border-subtle);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
  transition: width 200ms ease, min-width 200ms ease;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: var(--space-2) var(--space-4);
  min-height: 48px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-subtle);
}

:root[data-ui-density="compact"] .sidebar-header {
  padding: 6px 12px;
  min-height: 42px;
}

.sidebar-header h3 {
  margin: 0;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: var(--tracking-widest);
  flex: 1 1;
}

.sidebar-filter-toggle {
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 3px 5px;
  cursor: pointer;
  color: var(--text-muted);
  opacity: 0.5;
  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease;
  display: flex;
  align-items: center;
  line-height: 1;
}

.sidebar-filter-toggle:hover {
  opacity: 0.85;
  border-color: rgba(255, 255, 255, 0.08);
}

.sidebar-filter-toggle.active {
  opacity: 1;
  color: var(--text-secondary);
  border-color: rgba(255, 255, 255, 0.1);
}

/* Collapse toggle — unobtrusive header chevron, mirrors .sidebar-filter-toggle
   so the expanded sidebar looks unchanged save for one muted control. */
.sidebar-collapse-btn {
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 3px 5px;
  margin-left: 2px;
  cursor: pointer;
  color: var(--text-muted);
  opacity: 0.5;
  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease;
  display: flex;
  align-items: center;
  line-height: 1;
  flex-shrink: 0;
}

.sidebar-collapse-btn:hover {
  opacity: 0.9;
  color: var(--text-secondary);
  border-color: rgba(255, 255, 255, 0.08);
}

/* Re-open handle — small tab clipped to the left edge, only shown collapsed.
   position:fixed so it survives the aside shrinking to zero width. */
.sidebar-expand-handle {
  position: fixed;
  /* top:0 + height == .sidebar-header height so the handle's vertical centre
     lands on the collapse chevron's — the control doesn't jump on toggle. */
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 48px;
  padding: 0;
  border: 1px solid var(--border-subtle);
  border-left: none;
  border-radius: 0 8px 8px 0;
  background: rgba(15, 15, 18, 0.92);
  backdrop-filter: blur(8px);
  color: rgba(255, 255, 255, 0.45);
  cursor: pointer;
  z-index: 60;
  transition: width 150ms ease, color 150ms ease, background 150ms ease;
}

.sidebar-expand-handle:hover {
  width: 26px;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(30, 30, 36, 0.95);
}

:root[data-ui-density="compact"] .sidebar-expand-handle {
  height: 42px; /* matches compact .sidebar-header min-height */
}

:root[data-sidebar-collapsed="true"] .sidebar-expand-handle {
  display: flex;
}

.sidebar-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-3);
}

:root[data-ui-density="compact"] .sidebar-content {
  padding: 10px;
}

/* When the sole child is an empty-state dashed box, drop the scroll-wrapper
   padding so the flex-grow child can span the full content area. The empty
   state supplies its own margins. */
.sidebar-content:has(> .sidebar-empty:only-child) {
  padding: 0;
}

.sidebar-content::-webkit-scrollbar {
  width: 6px;
}

.sidebar-content::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background: var(--border-default);
  border-radius: var(--radius-sm);
}

.sidebar-content::-webkit-scrollbar-thumb:hover {
  background: var(--border-strong);
}

.sidebar-empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3, 12px);
  min-height: 200px;
  padding: var(--space-6, 24px) var(--space-4, 16px);
  margin: var(--space-4, 16px) var(--space-3, 12px);
  border: 2px dashed var(--border-default, rgba(255, 255, 255, 0.12));
  border-radius: var(--radius-xl, 16px);
  color: var(--text-muted, #a1a1aa);
  text-align: center;
}

.sidebar-empty svg {
  color: var(--text-dim, #71717a);
}

.sidebar-empty p {
  margin: 0;
}

.sidebar-empty-label {
  font-size: var(--text-sm, 0.875rem) !important;
  font-weight: var(--font-weight-medium, 500);
  color: var(--text-secondary, #d4d4d8) !important;
}

.sidebar-empty-hint {
  font-size: var(--text-xs, 0.75rem) !important;
  color: var(--text-dim, #71717a) !important;
  line-height: 1.4;
  max-width: 220px;
}

.exploration-sidebar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.exploration-sidebar-label {
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.25);
  white-space: nowrap;
}

.exploration-sidebar-track {
  flex: 1 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
}

.exploration-sidebar-fill {
  height: 100%;
  background: linear-gradient(90deg, #ef4444, #f97316);
  border-radius: 2px;
  transition: width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.exploration-sidebar-count {
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 768px) {
  .sidebar-shell {
    display: none;
  }
  /* No sidebar on mobile → nothing to re-open. */
  .sidebar-expand-handle {
    display: none !important;
  }
}

/* ── Collapsed state ──────────────────────────────────────────────────────
   Zero the shared --sidebar-width token so the shell, the fixed corner dock
   (BottomLeftStatusRail, width:var(--sidebar-width)) and the carousel's
   available-width calc (max-width: calc(100vw - var(--sidebar-width))) all
   reclaim the space together — every consumer already reads the token, so this
   one override is the whole collapse. !important + last-in-source beats every
   per-density and responsive --sidebar-width declaration above regardless of
   cascade specificity. The 2:1 sidebar:tray-height ratio invariant governs the
   per-density DEFAULTS; collapse is an intentional runtime override and leaves
   --carousel-tray-height intact. Must come AFTER the @media blocks above. */
:root[data-sidebar-collapsed="true"] {
  --sidebar-width: 0px !important;
}

:root[data-sidebar-collapsed="true"] .sidebar-shell {
  border-right-color: transparent;
}

/* The anon /play demo intentionally inherits the STANDARD carousel tokens so its
   concept-card tray is byte-identical to the logged-in app everywhere else. Do NOT
   pin the demo to a compact size here: the logged-in app runs at STANDARD density
   (240px cards), not compact, so a demo-only 188px override made the demo tray read
   NARROWER than everywhere else (the recurring "standalone tray looks different"
   regression). The static-track var fix in ConceptCardCarousel.css already keeps the
   demo's few-card tray at the same width as the looping tray. */
`, "",{"version":3,"sources":["webpack://./src/components/SidebarShell/SidebarShell.css"],"names":[],"mappings":"AAAA;;;;;;;;+DAQ+D;AAC/D;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE;;;;IAIE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;IAIE,oBAAoB;EACtB;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,sCAAsC;EACtC,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;wEACwE;AACxE;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;qEACqE;AACrE;EACE,eAAe;EACf;4EAC0E;EAC1E,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC;EAElC,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;oCAEoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,kDAAkD;EAClD,iDAAiD;EACjD,mEAAmE;EACnE,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE;IACE,aAAa;EACf;EACA,+CAA+C;EAC/C;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;;;;;;4EAS4E;AAC5E;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;gEAMgE","sourcesContent":["/* DESIGN INVARIANT (2026-05-19):\n   --sidebar-width and --carousel-tray-height MUST hold a 2:1 ratio\n   (sidebar = 2 × tray). The carousel tray height MUST equal the bottom-left\n   status dock (.corner-dock) min-height at the same density so they sit\n   flush along their top edge. The tray height also needs ~10px breathing\n   over the dock's natural content floor so the inner rows don't feel\n   cramped — standard = 140 (content floor 134 + 6 breathing), compact = 110\n   (content floor 104 + 6 breathing). See wiki/decisions/2026-05-19-dock-carousel-sidebar-proportion.md\n   Source of truth for dock floors: BottomLeftStatusRail.css. */\n:root {\n  --sidebar-width: 280px;\n  --carousel-tray-height: 140px;\n  --carousel-thumb-height: 120px;\n  --carousel-thumb-width: 240px;\n  --carousel-bar-pad-top: 16px;\n  --carousel-bar-pad-bottom: 12px;\n}\n\n:root[data-ui-density=\"compact\"] {\n  --sidebar-width: 220px;\n  --carousel-tray-height: 110px;\n  --carousel-thumb-height: 86px;\n  --carousel-thumb-width: 188px;\n  --carousel-bar-pad-top: 8px;\n  --carousel-bar-pad-bottom: 6px;\n}\n\n:root[data-ui-density=\"standard\"] {\n  --sidebar-width: 280px;\n  --carousel-tray-height: 140px;\n  --carousel-thumb-height: 120px;\n  --carousel-thumb-width: 240px;\n  --carousel-bar-pad-top: 16px;\n  --carousel-bar-pad-bottom: 12px;\n}\n\n:root[data-ui-density=\"spacious\"] {\n  --sidebar-width: 340px;\n  --carousel-tray-height: 170px;\n  --carousel-thumb-height: 144px;\n  --carousel-thumb-width: 280px;\n  --carousel-bar-pad-top: 22px;\n  --carousel-bar-pad-bottom: 16px;\n}\n\n@media (max-width: 1024px) {\n  :root,\n  :root[data-ui-density=\"compact\"],\n  :root[data-ui-density=\"standard\"],\n  :root[data-ui-density=\"spacious\"] {\n    --sidebar-width: 260px;\n  }\n}\n\n@media (max-width: 768px) {\n  :root,\n  :root[data-ui-density=\"compact\"],\n  :root[data-ui-density=\"standard\"],\n  :root[data-ui-density=\"spacious\"] {\n    --sidebar-width: 0px;\n  }\n}\n\n.sidebar-shell {\n  width: var(--sidebar-width);\n  min-width: var(--sidebar-width);\n  background: transparent;\n  border-right: 1px solid var(--border-subtle);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex-shrink: 0;\n  transition: width 200ms ease, min-width 200ms ease;\n}\n\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  padding: var(--space-2) var(--space-4);\n  min-height: 48px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n:root[data-ui-density=\"compact\"] .sidebar-header {\n  padding: 6px 12px;\n  min-height: 42px;\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-widest);\n  flex: 1;\n}\n\n.sidebar-filter-toggle {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  padding: 3px 5px;\n  cursor: pointer;\n  color: var(--text-muted);\n  opacity: 0.5;\n  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n\n.sidebar-filter-toggle:hover {\n  opacity: 0.85;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.sidebar-filter-toggle.active {\n  opacity: 1;\n  color: var(--text-secondary);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Collapse toggle — unobtrusive header chevron, mirrors .sidebar-filter-toggle\n   so the expanded sidebar looks unchanged save for one muted control. */\n.sidebar-collapse-btn {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  padding: 3px 5px;\n  margin-left: 2px;\n  cursor: pointer;\n  color: var(--text-muted);\n  opacity: 0.5;\n  transition: opacity 150ms ease, color 150ms ease, border-color 150ms ease;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.sidebar-collapse-btn:hover {\n  opacity: 0.9;\n  color: var(--text-secondary);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n/* Re-open handle — small tab clipped to the left edge, only shown collapsed.\n   position:fixed so it survives the aside shrinking to zero width. */\n.sidebar-expand-handle {\n  position: fixed;\n  /* top:0 + height == .sidebar-header height so the handle's vertical centre\n     lands on the collapse chevron's — the control doesn't jump on toggle. */\n  top: 0;\n  left: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 48px;\n  padding: 0;\n  border: 1px solid var(--border-subtle);\n  border-left: none;\n  border-radius: 0 8px 8px 0;\n  background: rgba(15, 15, 18, 0.92);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  color: rgba(255, 255, 255, 0.45);\n  cursor: pointer;\n  z-index: 60;\n  transition: width 150ms ease, color 150ms ease, background 150ms ease;\n}\n\n.sidebar-expand-handle:hover {\n  width: 26px;\n  color: rgba(255, 255, 255, 0.9);\n  background: rgba(30, 30, 36, 0.95);\n}\n\n:root[data-ui-density=\"compact\"] .sidebar-expand-handle {\n  height: 42px; /* matches compact .sidebar-header min-height */\n}\n\n:root[data-sidebar-collapsed=\"true\"] .sidebar-expand-handle {\n  display: flex;\n}\n\n.sidebar-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--space-3);\n}\n\n:root[data-ui-density=\"compact\"] .sidebar-content {\n  padding: 10px;\n}\n\n/* When the sole child is an empty-state dashed box, drop the scroll-wrapper\n   padding so the flex-grow child can span the full content area. The empty\n   state supplies its own margins. */\n.sidebar-content:has(> .sidebar-empty:only-child) {\n  padding: 0;\n}\n\n.sidebar-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb {\n  background: var(--border-default);\n  border-radius: var(--radius-sm);\n}\n\n.sidebar-content::-webkit-scrollbar-thumb:hover {\n  background: var(--border-strong);\n}\n\n.sidebar-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3, 12px);\n  min-height: 200px;\n  padding: var(--space-6, 24px) var(--space-4, 16px);\n  margin: var(--space-4, 16px) var(--space-3, 12px);\n  border: 2px dashed var(--border-default, rgba(255, 255, 255, 0.12));\n  border-radius: var(--radius-xl, 16px);\n  color: var(--text-muted, #a1a1aa);\n  text-align: center;\n}\n\n.sidebar-empty svg {\n  color: var(--text-dim, #71717a);\n}\n\n.sidebar-empty p {\n  margin: 0;\n}\n\n.sidebar-empty-label {\n  font-size: var(--text-sm, 0.875rem) !important;\n  font-weight: var(--font-weight-medium, 500);\n  color: var(--text-secondary, #d4d4d8) !important;\n}\n\n.sidebar-empty-hint {\n  font-size: var(--text-xs, 0.75rem) !important;\n  color: var(--text-dim, #71717a) !important;\n  line-height: 1.4;\n  max-width: 220px;\n}\n\n.exploration-sidebar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.exploration-sidebar-label {\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: rgba(255, 255, 255, 0.25);\n  white-space: nowrap;\n}\n\n.exploration-sidebar-track {\n  flex: 1;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.exploration-sidebar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #ef4444, #f97316);\n  border-radius: 2px;\n  transition: width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.exploration-sidebar-count {\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.35);\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 768px) {\n  .sidebar-shell {\n    display: none;\n  }\n  /* No sidebar on mobile → nothing to re-open. */\n  .sidebar-expand-handle {\n    display: none !important;\n  }\n}\n\n/* ── Collapsed state ──────────────────────────────────────────────────────\n   Zero the shared --sidebar-width token so the shell, the fixed corner dock\n   (BottomLeftStatusRail, width:var(--sidebar-width)) and the carousel's\n   available-width calc (max-width: calc(100vw - var(--sidebar-width))) all\n   reclaim the space together — every consumer already reads the token, so this\n   one override is the whole collapse. !important + last-in-source beats every\n   per-density and responsive --sidebar-width declaration above regardless of\n   cascade specificity. The 2:1 sidebar:tray-height ratio invariant governs the\n   per-density DEFAULTS; collapse is an intentional runtime override and leaves\n   --carousel-tray-height intact. Must come AFTER the @media blocks above. */\n:root[data-sidebar-collapsed=\"true\"] {\n  --sidebar-width: 0px !important;\n}\n\n:root[data-sidebar-collapsed=\"true\"] .sidebar-shell {\n  border-right-color: transparent;\n}\n\n/* The anon /play demo intentionally inherits the STANDARD carousel tokens so its\n   concept-card tray is byte-identical to the logged-in app everywhere else. Do NOT\n   pin the demo to a compact size here: the logged-in app runs at STANDARD density\n   (240px cards), not compact, so a demo-only 188px override made the demo tray read\n   NARROWER than everywhere else (the recurring \"standalone tray looks different\"\n   regression). The static-track var fix in ConceptCardCarousel.css already keeps the\n   demo's few-card tray at the same width as the looping tray. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
